const Kids = () => {
  return (
    <div>
      <h1>Gyermek Szolgáltatások</h1>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>Szolgáltatások</u>
        </h3>
        <span>Kid Fresh Manikűr/ Spa - 8000 Ft</span>
        <br></br>
        <span>Polírcsere kézen/lábon - 5000 Ft</span>
        <br></br>
        <span>Levegőre kötő lakk hozzáadása (kézre/lábra) - 5000 Ft</span>
        <br></br>
        <span>Kombinált gyerek manikűr + pedikűr - 10000 Ft</span>
        <br></br>
        <span>Kid Fresh gyógypedikűr - 12000 Ft</span>
        <br></br>
      </div>
      <br></br> <br></br>
    </div>
  );
};

export default Kids;
